import { SkeletonAvatar, SkeletonText } from '@dev-spendesk/grapes';

export const TripSkeleton = () => {
  return (
    <div className="bg-background-primary-default rounded-12 border-border-default flex flex-1 items-center justify-between border p-16">
      <div className="flex flex-col gap-4">
        <SkeletonText size="xl" width="240px" className="block" />
        <SkeletonText size="xl" width="120px" className="block" />
      </div>
      <SkeletonAvatar size="m" variant="square" />
    </div>
  );
};
